import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { selectUserId, selectWork, selectWorks } from '../../Api/selectors';
import { fetchVehicle } from '../../Vehicles/actions';
import { VehicleExtraCostCard } from '../../Vehicles/components/CardExtraCost';
import { REQUEST_VEHICLE } from '../../Vehicles/constants';
import { selectVehicle } from '../../Vehicles/selectors';

const Container = styled.div``;

const STATE = {
  vehicle: null,
};

/* eslint-disable react/prefer-stateless-function */
class KanbanExtraCostsWrapperComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    this.props.fetch();
  }

  render() {
    if (this.props.work || !this.props.vehicle) return <Loader small />;
    return (
      <Container>
        <VehicleExtraCostCard
          vehicle={this.props.vehicle}
          additionalCosts={this.props.additionalCosts}
          loggedUserId={this.props.loggedInUserId}
        />
      </Container>
    );
  }
}

KanbanExtraCostsWrapperComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_VEHICLE, `${REQUEST_VEHICLE}-${ownProps.vehicleId}`]),
    vehicle: selectVehicle(ownProps?.vehicleId),
    loggedInUserId: selectUserId(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchVehicle(ownProps.vehicleId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const KanbanExtraCostsWrapper = compose(withConnect, withRouter)(KanbanExtraCostsWrapperComp);
